import React from "react";
// import { withRouter } from "react-router-dom";
// import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Link } from "react-router-dom";

import { Layout, Menu, Avatar } from 'antd';
import Button from "antd-button-color";
import {
  UserOutlined,
  CarOutlined,
  ShopOutlined,
  FileTextOutlined,
  PoweroffOutlined,
  SettingOutlined
} from '@ant-design/icons';
import AppRoutes from "../routes";


const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;
class DesktopLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      level: null
    }
  }


  componentDidMount = () => {
    // console.log('this.props', this.props.userData.userData.level)
    this.setState({ level: this.props.userData.userData.level })
  }
  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  onCollapse = collapsed => {
    this.setState({ collapsed });
  };

  render() {
    const { collapsed } = this.state;
    const logout = this.props.userData.logout
    const userdata = this.props.userData.userData

    let activeMenu = []
    let openMenu = []
    let path = window.location.pathname
    // console.log('path', path);

    if (path.includes('/staff')) {
      activeMenu = '1'
    } else if (path === '/shop') {
      activeMenu = '2'
    } else if (path === "/shop/shopMap") {
      activeMenu = '5'
    } else if (path.includes('/track')) {
      activeMenu = '3'
    } else if (path.includes('/admin/region')) {
      activeMenu = '6'
      openMenu = 'sub6'
    } else if (path.includes('/admin/role')) {
      activeMenu = '7'
      openMenu = 'sub6'
    }

    // console.log('activeMenu', activeMenu)
    // console.log('activeMenua', activeMenua)
    return (
      <Layout>
        <Header className="" style={{ padding: 0, backgroundColor: '#a9c0ff' }}>
          {/* <h3></h3> */}
          <div style={{
            height: '100%',
            padding: '0px 20px',
            fontSize: '50px',
            fontWeight: 'bold',
            color: 'white',
            // cursor: 'pointer'
            float: 'left',
            textShadow: '3px 4px #888888',
          }}
          >
            Loxtrade
          </div>
          <Button
            with=""
            type="warning"
            shape="circle"
            icon={<PoweroffOutlined />}
            onClick={logout}
            size="large" style={{
              // height: '100%',
              // padding: '0px 20px',
              margin: '11px',
              fontWeight: 'bold',
              // color: 'white',
              float: 'right',
              textShadow: '3px 4px #888888',
            }} />

        </Header>
        <Layout className="site-layout">
          <Sider
            width='260'
            theme="light"
            collapsible
            collapsed={collapsed}
            onCollapse={this.onCollapse}
            style={{
              overflow: 'auto',
              left: 0,
            }}>
            <Avatar size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }} icon={<UserOutlined />} style={{ marginTop: "25px" }} />
            <h4
              style={{ marginTop: "10px", marginBottom: "10px" }}
              className="bold"
            >
              {userdata.firstName} {userdata.lastName}{" "}
            </h4>
            <h5
              style={{ marginTop: "0px", marginBottom: "25px" }}
              className="bold"
            >
              {userdata.levelDesc}
            </h5>

            <Menu theme="light" mode="inline" defaultSelectedKeys={activeMenu} defaultOpenKeys={openMenu}>
              <Menu.Item key="1" icon={<UserOutlined />}>
                <Link to="/staff" />
                <span>ข้อมูลพนักงานขาย</span>
              </Menu.Item>
              <Menu.Item key="2" icon={<ShopOutlined />}>
                <Link to="/shop" />
                <span>ข้อมูลร้านค้า</span>
              </Menu.Item>
              <Menu.Item key="5" icon={<ShopOutlined />}>
                <Link to="/shop/shopMap" />
                <span>แผนที่ร้านค้า</span>
              </Menu.Item>
              <Menu.Item key="3" icon={<CarOutlined />}>
                <Link to="/track" />
                <span>Track View Sale</span>
              </Menu.Item>
              <Menu.Item key="8" icon={<FileTextOutlined />}>
                <Link to="/location_view" />
                <span>Location view</span>
              </Menu.Item>
              <Menu.Item key="4" icon={<FileTextOutlined />}>
                <Link to="/report" />
                <span>Report Sale</span>
              </Menu.Item>
              {this.state.level == 99 &&
                <SubMenu key="sub6" icon={<SettingOutlined />} title="Administrator">
                  <Menu.Item key="6" icon={<FileTextOutlined />}>
                    <Link to="/admin/region" />
                    <span>จัดการกลุ่มผู้ใช้งาน</span>
                  </Menu.Item>
                  <Menu.Item key="7" icon={<FileTextOutlined />}>
                    <Link to="/admin/role" />
                    <span>จัดการสิทธิ์ผู้ใช้งาน</span>
                  </Menu.Item>
                </SubMenu>
              }
            </Menu>
          </Sider>
          <Layout>
            <Content style={{ margin: '10px 10px', padding: 24, background: '#fff', height: '100%' }}>
              <AppRoutes userdata={userdata} />
            </Content>
          </Layout>
        </Layout>
      </Layout>
    );
  }
}

// export default withRouter(DesktopLayout);
export default DesktopLayout;
